<template lang="pug">
    div
        Card.a8-page-description-card
            h2 {{ $t('recordLineGroups.pageTitleText') }}
            p Build your own custom record line with record line groups.
            strong You have created {{ usage.used }} of {{ usage.max }} recordline groups.

        // h2 {{ $t('recordLineGroups.pageTitleText') }}
        RcmTable(
            :esIndex="esIndex"
            :esIndexFields="esIndexFields"
            :addButtonText="addButtonText"
            :userCanCreate="true"
            :userCanIndex="true"
            :userCanDelete="true"
            :actionInTable="true"
            :drawerTitleKey="drawerTitleKey"
            :sort="sort"
            ref="rcmTable"
            :searchView="$options.name"
            :sectionInfo="sectionInfo"
            primarySearchKey="recordLineGroupName"
            :primarySearchKeyI18="$t('recordLineGroups.recordLineGroupName')"
            :isCreateBtnDisabled="!$can('write', 'groupResourcesPermission','RecordLineGroups')"
            :isEditBtnDisabled="!$can('write', 'groupResourcesPermission','RecordLineGroups')"
            :isDeleteBtnDisabled="!$can('write', 'groupResourcesPermission','RecordLineGroups')"
        )
</template>
<script>
import Vue from "vue";
Vue.component("TagList", TagList);

import RcmTable from "@/components/RcmTable_v2";
import bus from "@/libs/bus.js";
import TagList from "@/components/TagList";
import JsonPoptip from "@/components/JsonPoptip";
import ObjectLogBtn from "@/components/ObjectLogBtn";

Vue.component("JsonPoptip", JsonPoptip);
Vue.component("ObjectLogBtn", ObjectLogBtn);

import { formSlot, settingZoneExplain, recordLineGroupName, line } from "./fields.js";

import { getGroupAsset } from "@/api/groupasset.js";

export default {
    name: "RecordLineGroups",
    components: { RcmTable, TagList },
    data() {
        return {
            esIndex: "rcm-recordline-groups",
            drawerTitleKey: "groupName",
            sort: [{ modifiedDate: { order: "desc" } }],
            assetCategory: "recordLineGroups",
            usage: { used: "", max: "", available: "" }
        };
    },
    computed: {
        addButtonText() {
            return this.$i18n.t("recordLineGroups.createText");
        },
        sectionInfo() {
            return [];
        },
        esIndexFields() {
            return this.$store.getters.isAdmin
                ? {
                      action: {},
                      formSlot: formSlot(this),
                      createBy: {},
                      settingZoneExplain: settingZoneExplain(this),
                      groupName: {},
                      recordLineGroupName: recordLineGroupName(this),
                      line: line(this),
                      createdDate: {},
                      modifiedDate: {},
                      status: {},
                      objectLog: {}
                  }
                : {
                      action: {},
                      formSlot: formSlot(this),
                      createBy: {},
                      settingZoneExplain: settingZoneExplain(this),
                      groupName: {},
                      recordLineGroupName: recordLineGroupName(this),
                      line: line(this),
                      createdDate: {},
                      modifiedDate: {},
                      status: {},
                      objectLog: {}
                  };
        }
    },
    methods: {
        getAssetData() {
            getGroupAsset({
                category: this.assetCategory,
                groupNames: [this.$store.state.queryGroupName]
            }).then(res => {
                let { used, max } = res.data;
                let available = max - used;
                this.usage = { used, max, available };
            });
        }
    },
    mounted() {
        this.getAssetData();
    },
    created() {
        // 監聽以自己組件為名的事件
        bus.$on(this.$options.name, busEvent => {
            bus.$emit(busEvent);
        });
    },
    destroyed() {},
    beforeDestroy() {
        bus.$off(this.$options.name);
    }
};
</script>



// WEBPACK FOOTER //
// src/view/RecordLineGroups/Page.vue